export const machineLearningSelector = state => state.machineLearning;
